import { Resource } from 'src/app/global/domain/resource.model';
import { ConciliacaoDTO } from './dto/conciliacao.dto';
import { TipoConciliacaoBancaria } from './enum/tipo-conciliacao-bancaria.enum';

export class ConciliacaoBancariaTed extends Resource {
  data: Date;

  name: string;

  identificador: string;

  tipoConciliacaoBancaria: TipoConciliacaoBancaria;

  banco: number;

  valor: number;

  valorPago: number;

  processado: boolean;

  contaOrigem: string;

  contaDestino: string;

  public static toConciliacaoDTO(conciliacao: ConciliacaoBancariaTed): ConciliacaoDTO {
    let dto: ConciliacaoDTO = {
      id: conciliacao.id,
      version: conciliacao.version,
      ativo: conciliacao.ativo,
      selecionado: conciliacao.selecionado,
      acoes: conciliacao.acoes,
      data: conciliacao.data,
      name: conciliacao.name,
      identificador: conciliacao.identificador,
      tipoConciliacaoBancaria: conciliacao.tipoConciliacaoBancaria,
      banco: conciliacao.banco,
      valor: conciliacao.valor,
      contaDestino: conciliacao.contaDestino,
      contaOrigem: conciliacao.contaOrigem,
      responsavel: null,
      processado: conciliacao.processado,
      valorPago: conciliacao.valorPago,
      agencia: null,
      conta: null,
    };
    return dto;
  }
}
